import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';

interface BaseBorderColorOptionProps {
  solidBorderColor: RGBA;
  onClickColorFill(): void;
  className?: string;
}

export function BaseBorderColorOption({className = '', ...props}: BaseBorderColorOptionProps): ReactElement<any> {
  const getColorDataObject = (): ColorFillStorage[] => {
    return [
      {
        id: 'color-object',
        color: getColorObjectArrayFromFillColor([props.solidBorderColor]),
      },
    ];
  };

  return (
    <ContextualMenuColorFillOption
      className={className}
      id="item-border-color-option"
      label={window.i18next.t('pmwjs_color')}
      data={getColorDataObject()}
      onClick={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
